import { Component, OnInit, Renderer2 } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ServiceService } from "src/app/services/service.service";
import iziToast from 'izitoast';
import Swal from 'sweetalert2';
import { Router } from "@angular/router";
import { Color, Label } from "ng2-charts/ng2-charts";
// import { ChartConfiguration, ChartDataSets, ChartOptions, ChartType } from 'chart.js';
// import * as Chart from 'chart.js';
import {
  Chart,
  ChartConfiguration,
  ChartDataSets,
  ChartOptions,
  ChartType
} from "chart.js";

declare var $: any;
@Component({
  selector: "app-usersdashboard",
  templateUrl: "./usersdashboard.component.html",
  styleUrls: ["./usersdashboard.component.css"]
})
export class UsersdashboardComponent implements OnInit {
  userdetails: any;
  chartRef: any;
  status: string = "Active";
  value: boolean = false;
  expire_time: any;
  account_state: any;
  active_plan: any;
  q1_plan_name: any;
  daily_dq_usage: any;
  weekly_dq_usage: any;
  monthly_dq_usage: any;
  monthly_dq_sts: any;
  daily_tq_usage: any;
  weekly_tq_usage: any;
  monthly_tq_usage: any;
  monthly_tq_sts: any;
  total_days: any;
  q1_max_mb_text: any;
  q1_max_time_text: any;
  q1_price: any;
  uploadBandwidthKbps: any;
  downloadBandwidthKbps: any;
  maxUploadMbps = 100;
  maxDownloadMbps = 100;
  q1_up_kbps_text: any;
  q1_dn_kbps_text: any;
  user_id: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;
  user_firstname: any;
  user_lastname: any;
  user_number: any;
  total_dq_limit: number | 'unlimited' = 'unlimited';
  private overlay: HTMLElement | null = null;
  constructor(
    private http: HttpClient,
    private router: Router,
    private ServerService: ServiceService,
    private renderer: Renderer2
  ) { }
  currentDateTime: string = "";
  ngOnInit(): void {

    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');

    this.updateDateTime();
    setInterval(() => this.updateDateTime(), 1000);
    this.postData();

    this.UserDetailes();
  }
  updateDateTime() {
    const now = new Date();
    this.currentDateTime = now.toLocaleString();
  }

  renewal() {
    this.router.navigate(['/upgrade-plan']);
  }


  show() {
    this.status = "Active";
    this.value = true;
  }


  get isUnlimited(): boolean {
    return this.total_dq_limit === 'unlimited';
  }

  get usageBarWidth(): string {
    if (this.isUnlimited) {
      return '100%'; // optional: could be 50% just to show symbolic progress
    }

    const usage = Number(this.daily_dq_usage);
    const limit = Number(this.total_dq_limit);

    const percentage = limit ? Math.min(100, (usage / limit) * 100) : 0;
    return percentage + '%';
  }


  convertKbpsToMbps(value: string): number {
    const kbps = parseFloat(value);
    return isNaN(kbps) ? 0 : kbps / 1000;
  }

  // Getters for binding in template
  get uploadBandwidthMbps(): number {
    return this.convertKbpsToMbps(this.q1_up_kbps_text);
  }

  get downloadBandwidthMbps(): number {
    return this.convertKbpsToMbps(this.q1_dn_kbps_text);
  }

  convertMinutesToTimeFormat(value: string): string {
    const totalMinutes = parseInt(value);
    if (isNaN(totalMinutes)) return "0 min";

    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    const daysPart = days > 0 ? `${days} day${days > 1 ? "s" : ""} ` : "";
    const hoursPart = hours > 0 ? `${hours} hr${hours > 1 ? "s" : ""} ` : "";
    const minutesPart = `${minutes} min`;

    return daysPart + hoursPart + minutesPart;
  }

  UserDetailes() {
    var data: any = new FormData();
    // data.append("api_version", this.api_version);
    // data.append("client_id", this.client_id);
    // data.append("ps_key", this.ps_key);
    // data.append("nas_id", this.nas_id);
    data.append("action_id", "show_user_id_details");
    data.append("action", "get_url");
    data.append("req_params", JSON.stringify({ user_id: this.user_id }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://chettinadlink.com/zoho-apis/",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {

        if (result.success == true || result.success == "true") {

          let userdetails = result.results;

          // console.log("userdetails", userdetails);
          // Loop through and assign values to class properties
          userdetails.forEach((item: any) => {
            switch (item.fid) {
              case "expire_time":
                self.expire_time = item.value;
                localStorage.setItem('expiredDate', self.expire_time)
                self.expire_time = self.expire_time.split(",")[0];

                break;
              case "account_state":
                self.account_state = item.value;
                break;
              case "active_plan":
                self.active_plan = item.value;
                break;
              case "q1_price":
                self.q1_price = item.value;
                break;
              case "q1_plan_name":
                self.q1_plan_name = item.value;
                break;
              case "q1_max_mb_text":
                self.q1_max_mb_text = item.value;
                break;
              case "q1_max_time_text":
                self.q1_max_time_text = item.value;
                break;
              case "q1_up_kbps_text":
                self.q1_up_kbps_text = item.value;
                break;
              case "q1_dn_kbps_text":
                self.q1_dn_kbps_text = item.value;
                break;

              ////////  Data usage ////////

              // Data :

              case "daily_dq_usage":
                self.daily_dq_usage = item.value;
                break;
              case "weekly_dq_usage":
                self.weekly_dq_usage = item.value;
                break;
              case "monthly_dq_usage":
                self.monthly_dq_usage = item.value;
                break;
              case "monthly_dq_sts":
                self.monthly_dq_sts = item.value;
                self.monthly_dq_sts = self.monthly_dq_sts.split(",")[0];
                break;

              // Time :

              case "daily_tq_usage":
                self.daily_tq_usage = self.convertMinutesToTimeFormat(
                  item.value
                );
                break;
              case "weekly_tq_usage":
                self.weekly_tq_usage = self.convertMinutesToTimeFormat(
                  item.value
                );
                break;
              case "monthly_tq_usage":
                self.monthly_tq_usage = self.convertMinutesToTimeFormat(
                  item.value
                );
                break;
              case "monthly_tq_sts":
                self.monthly_tq_sts = item.value;
                break;
            }
          });
        } else {
        }
      }
    });
  }


  postData() {
    const body = new HttpParams()
      // .set("api_version", this.api_version)
      // .set("client_id", this.client_id)
      // .set("ps_key", this.ps_key)
      // .set("nas_id", this.nas_id)
      .set("action_id", "get_user_record")
      .set("action", "get_url")
      .set(
        "req_params",
        JSON.stringify({ req_id: "string", user_id: this.user_id })
      );

    // Set headers
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });

    this.ServerService.sendServer2(body.toString(), headers).subscribe(
      (response: any) => {

        if (response && response.results) {
          this.user_firstname = response.results.first_name
            ? response.results.first_name.toUpperCase()
            : '';

          this.user_lastname = response.results.last_name
            ? response.results.last_name.toUpperCase()
            : '';

          this.user_number = response.results.user_id ?? '';
        } else {
          this.user_firstname = '';
          this.user_lastname = '';
          this.user_number = '';
        }
      },
      (error) => {
        console.error("API Error:", error);
      }
    );
  }

  isPayBillEnabled1(): boolean {
    if (this.account_state === 'Expired') {
      return true;
    }

    if (this.account_state === 'Active') {
      if (!this.expire_time) return false;

      const currentYear = new Date().getFullYear();

      // Parse start and end dates
      // const startDate = new Date(`${this.monthly_dq_sts} ${currentYear}`);
      const endDate = new Date(`${this.expire_time} ${currentYear}`);

      // Normalize to midnight
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      // Calculate the start of the last 7-day window
      const last3Start = new Date(endDate);
      last3Start.setDate(endDate.getDate() - 2); // Includes end day itself

      return today >= last3Start && today <= endDate;
    }

    return false; // Disabled for all other account states
  }

  isPayBillEnabled(): boolean {
  if (this.account_state === 'Expired' || this.account_state === 'Active') {
    if (!this.expire_time) return false;

    const currentYear = new Date().getFullYear();
    const endDate = new Date(`${this.expire_time} ${currentYear}`);

    // Normalize to midnight
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    // Calculate 3 days before and after expiry date
    const startWindow = new Date(endDate);
    startWindow.setDate(endDate.getDate() - 3);

    const endWindow = new Date(endDate);
    endWindow.setDate(endDate.getDate() + 3);

    // Enable button if today is within that 7-day window
    return today >= startWindow && today <= endWindow;
  }

  return false; // Disabled for all other states
}



  validateAndPay(planName: any, planPrice: any) {
    const q1Price = Number(this.q1_price);
    if (Number(planPrice) >= q1Price) {
      Swal.fire({
        title: `Upgrade to ${planName}`,
        html: `
        <strong>Price:</strong> ₹${planPrice}<br>
        <strong>Upload:</strong> ${this.uploadBandwidthMbps} Mbps<br>
        <strong>Download:</strong> ${this.downloadBandwidthMbps} Mbps<br>
        <strong>Validity:</strong> 30 Days<br><br>
        <em>Are you sure you want to activate this plan?</em>
      `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Upgrade Now!',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.invoicePayment(planName, planPrice);

        }
      });

    } else {
      iziToast.error({
        message: 'This plan is not available. Please contact admin.',
        position: 'topRight'
      });
    }
  }

  loaderStart() {
    // Create overlay and loader only when API is called
    this.overlay = this.renderer.createElement('div');
    const loader = this.renderer.createElement('div');

    this.renderer.addClass(this.overlay, 'overlay');
    this.renderer.addClass(loader, 'loader');

    loader.innerHTML = 'Loading...'; // Optional text

    this.renderer.appendChild(this.overlay, loader);
    this.renderer.appendChild(document.body, this.overlay);
  }
  loaderEnd() {
    this.renderer.removeChild(document.body, this.overlay);
  }

  invoicePayment(plan_name: any, plan_price: any) {

    this.loaderStart();

    this.router.navigate(['/invoice-payment'], {
      queryParams: {
        plan_name: plan_name,
        plan_price: plan_price,
      }
    });
    this.loaderEnd(); // Remove loader





  }








}
